import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import SectionHeader from './SectionHeader'
import DownloadableResource from './DownloadableResource'
import useIsMobile from '../hooks/useIsMobile'

const resourcesCss = css`
  display: grid;
  grid-row-gap: 8px;
`

const DownloadableResources = ({ downloadableResources = [] }) => {
  const [t] = useTranslation()
  const isMobile = useIsMobile()
  return (
    <>
      <SectionHeader small={isMobile} heading={t('virtual-booth.downloadable-resources', 'Downloadable Resources')} />
      <div css={resourcesCss}>
        {downloadableResources.map((content) => (
          <DownloadableResource key={content.href} {...content} />
        ))}
      </div>
    </>
  )
}

export default DownloadableResources
